'use client';

import axios from 'axios';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import QuizrrLogo from '../../public/Images/QuizrrWhite.svg';

function PromoBannerShell({ children, className = '' }) {
  if (!children) return null;
  return <div className={`w-full max-w-[min(100%,450px)] rounded-2xl overflow-hidden  ${className}`}>{children}</div>;
}

export function PromoSidebar({ isMobile = false, isTabletTop = false, isTabletBottom = false, promoBanner = null }) {
  const [fetchedExams, setFetchedExams] = useState([]);

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const res = await axios.get(`/api/user/profile/allExams`);
      if (res.data && res.data.success && res.data.data && res.data.data.exams) {
        const formattedExams = res.data.data.exams
          .filter((exam) => exam.shortName !== 'VITEEE, MET, SRMJEEE')
          .map((exam) => ({
            name: exam.shortName || exam.title,
            icon: exam.icon,
          }))
          .filter((exam) => exam.icon && exam.name)
          .sort((a, b) => a.position - b.position);

        setFetchedExams(formattedExams);
      }
    } catch (error) {
      console.error('Error fetching exams:', error);
    }
  };

  const examsToDisplay = fetchedExams.length > 0 ? fetchedExams : [];

  if (isMobile) {
    return (
      <div className="text-[#ffffff] text-center flex flex-col justify-center h-full pt-15 relative">
        <div className="absolute inset-0" style={{ backgroundColor: 'transparent' }} />
        <div className="relative z-10 flex flex-col gap-4 px-8">
          <div className="mb-4 md:mb-8">
            <img src={QuizrrLogo || '/placeholder.svg'} alt="Quizrr" className="h-12 w-auto mx-auto" />
            <div className="ml-2 mt-2 flex flex-row items-center justify-center gap-2">
              Powered by{' '}
              <img className="w-[100px]" src="https://cdn.mathongo.com/images/email/logo-light.png" alt="MathonGo" />
            </div>
          </div>

          <div className="mb-5 md:mb-8">
            <div className="text-lg font-bold leading-tight">
              AYJR (Advanced):{' '}
              <span className="relative">
                <span className="italic " style={{ color: '#FFF091' }}>
                  Country's <u>Biggest</u> Open Mock Test
                </span>{' '}
              </span>
              <br />
            </div>
          </div>

          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <span className="mt-2 w-2 h-2 bg-white rounded-full shrink-0" />
              <p className="font-light leading-snug">
                Compete with <span className="font-semibold">1 Lakh+</span> aspirants
              </p>
            </div>

            <div className="flex items-start gap-3">
              <span className="mt-2 w-2 h-2 bg-white rounded-full shrink-0" />
              <p className="leading-snug text-start">
                Get the feel of <span className="font-semibold">of actual JEE Advanced</span> before real exam
              </p>
            </div>

            <div className="flex items-start gap-3">
              <span className="mt-2 w-2 h-2 bg-white rounded-full shrink-0" />
              <p className="leading-snug text-start">
                Predicted <span className="font-semibold">percentile & detailed analysis</span> of your performance
              </p>
            </div>
          </div>

          {promoBanner && (
            <div className="mt-6 md:mt-8 flex justify-center">
              <PromoBannerShell className="mx-auto">{promoBanner}</PromoBannerShell>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (isTabletTop) {
    return (
      <div className="text-[#ffffff] text-center relative">
        <div className="absolute inset-0" style={{ backgroundColor: 'transparent' }} />
        <div className="relative z-10">
          {/* Logo */}
          <div className="mb-4">
            <img src={QuizrrLogo || '/placeholder.svg'} alt="Quizrr" className="h-16 w-auto mx-auto" />
            <div className="ml-2 mt-2 flex flex-row items-center justify-center gap-2">
              Powered by{' '}
              <img className="w-[100px]" src="https://cdn.mathongo.com/images/email/logo-light.png" alt="MathonGo" />
            </div>
          </div>

          {/* Title */}
          <div>
            <div className="text-2xl font-bold leading-tight">
              AYJR (Advanced):{' '}
              <span className="relative">
                <span className="italic" style={{ color: '#FFF091' }}>
                  Country's <u>Biggest</u> Open Mock Test
                </span>{' '}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isTabletBottom) {
    return (
      <div className="text-[#ffffff] text-center relative">
        <div className="absolute inset-0" style={{ backgroundColor: 'transparent' }} />
        <div className="relative z-10">
          <div className="mb-8 space-y-3 text-lg max-w-2xl mx-auto">
            <div className="flex items-center justify-center space-x-3">
              <div className="w-2 h-2 bg-white rounded-full flex-shrink-0" />
              <p className="font-light">
                Compete with <span className="font-semibold">1 Lakh+</span> aspirants all over India
              </p>
            </div>

            <div className="flex items-center justify-center space-x-3">
              <div className="w-2 h-2 bg-white rounded-full flex-shrink-0" />
              <p>
                Get the feel of <span className="font-semibold">of actual JEE Advanced</span> before real exam
              </p>
            </div>

            <div className="flex items-center justify-center space-x-3">
              <div className="w-2 h-2 bg-white rounded-full flex-shrink-0" />
              <p>
                Predicted <span className="font-semibold">percentile & detailed analysis</span> of your performance
              </p>
            </div>
          </div>

          {promoBanner && (
            <div className="mt-8 flex justify-center">
              <PromoBannerShell className="mx-auto">{promoBanner}</PromoBannerShell>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-[550px] relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: 'transparent',
        }}
      />

      <div className="relative z-10 flex flex-col justify-center gap-10 px-0 py-10 text-[#ffffff] w-full">
        <div className="">
          <img src={QuizrrLogo || '/placeholder.svg'} alt="Quizrr" className="h-15 w-auto" />
          <div className="ml-2 mt-2 flex flex-row items-center justify-start gap-2">
            Powered by{' '}
            <img className="w-[100px]" src="https://cdn.mathongo.com/images/email/logo-light.png" alt="MathonGo" />
          </div>
        </div>

        <div className="flex flex-col justify-center space-y-2">
          <div>
            <div className="text-5xl font-bold leading-tight mb-4">
              AYJR (Advanced):{' '}
              <span className="relative">
                <span className="italic " style={{ color: '#FFF091' }}>
                  Country's <u>Biggest</u> Open Mock Test
                </span>
              </span>
              <br />
            </div>
          </div>

          <div className="space-y-2 text-lg">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full" />
              <p className="text-lg font-light">
                Compete with <span className="font-semibold">1 Lakh+</span> aspirants
              </p>
            </div>

            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full" />
              <p className="text-lg">
                Get the feel of <span className="font-semibold">of actual JEE Advanced</span> before real exam
              </p>
            </div>

            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full" />
              <p className="text-lg">
                Predicted <span className="font-semibold">percentile & detailed analysis</span> of your performance
              </p>
            </div>
          </div>

          {promoBanner && (
            <div className="mt-8">
              <PromoBannerShell>{promoBanner}</PromoBannerShell>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
